import React from 'react';

import { PageLayout } from 'src/core/components';
import OligoDNA from 'src/components/OligoDNA';
import { DNA_TYPE } from 'src/constants/forms';

export const OligoDNAPage = () => {
  React.useEffect(() => {
    localStorage.setItem(DNA_TYPE, window.location.search);
  }, []);

  return (
    <PageLayout withBreadCrumbs={false}>
      <OligoDNA />
    </PageLayout>
  );
};

OligoDNAPage.propTypes = {};

export default OligoDNAPage;
